import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';
import { addUsuarioCentro, removeUsuarioCentro, modifyUsuarioCentro } from '../../actions/perfiles_usuario_centros_actions';

const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

const perfiles = [
    { id: 0, perfil: 'Super Administrador - old' },
    { id: 1, perfil: 'Invitado - old' },
    { id: 2, perfil: 'Administrativo/a Central - old' },
    { id: 3, perfil: 'Gerente - old' },
    { id: 4, perfil: 'Director - old' },
    { id: 5, perfil: 'Director Administrativo/a - old' },
    { id: 6, perfil: 'Recepcionista - old' },
    { id: 7, perfil: 'Mecánico Central - old' },
    { id: 8, perfil: 'Encargada/o de Centro - old' },
    { id: 10, perfil: 'Socio - old' },
    { id: 11, perfil: 'Consultor CheckList - old' },
    //nuevos perfiles
    { id: 12, perfil: 'Recepción' },
    { id: 13, perfil: 'Op. Encargado' },
    { id: 14, perfil: 'Gerencia' },
    { id: 15, perfil: 'Supervisor Zona' },
    { id: 16, perfil: 'Administrativo Zona' },
    { id: 17, perfil: 'Dirección Administración' },
    { id: 18, perfil: 'Dirección Operaciones' },
    { id: 19, perfil: 'Dirección Marketing' },
    { id: 20, perfil: 'Dirección General' },
    { id: 21, perfil: 'Socio/Invitado' },
    { id: 22, perfil: 'Central de Compras'},
    { id: 23, perfil: 'Marketing'},
]

class UsuarioCentros extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            usuarioCentros: []
        }
    }

    componentDidUpdate = (prevProps) => {

        if (prevProps.usuarioCentros !== this.props.usuarioCentros) {
            const centros_usuario = this.props.usuarioCentros.map((uc, index) => {
                return {
                    id: uc.id,
                    usuarioId: uc.usuarioId,
                    centroId: uc.centroId,
                    iPerfil: uc.iPerfil,
                    centro: this.props.centros.find(c => c.id === uc.centroId).centro,
                    perfil: perfiles.find(p => p.id === uc.iPerfil).perfil,

                }
            });
            this.setState({ ...this.state, usuarioCentros: centros_usuario });
        }
    }

    addCentro = (centro) => {
        this.props.setSaveState(true);
        this.props.addUsuarioCentro(centro);
    };

    modifyCentroUsuario = (centro) => {
        this.props.setSaveState(true);
        this.props.modifyUsuarioCentro(centro);
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, "message_usuario_centros", false, 'sm');

    };

    checkCentro = (centro) => {

        return true;
    };

    newCentro = () => {

        this.props.openDialog('EditCentroUsuario', {
            centro: {},
            centros: this.props.centros,
            usuarioId: this.props.id,
            perfiles: perfiles,
            okHandler: this.addCentro,
            checkCentro: this.checkCentro,
        }, "new_usuario_centro_dialog");

    };

    editCentro = (centro) => {

        this.props.openDialog('EditCentroUsuario', {
            centro,
            centros: this.props.centros,
            usuarioId: this.props.id,
            perfiles: perfiles,
            okHandler: this.modifyCentroUsuario,
            checkCentro: this.checkCentro
        }, "edit_centro_centro_dialog");

    };

    removeCentro = (centro, index) => {
        this.props.setSaveState(true);
        this.props.removeUsuarioCentro(centro);
    };

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Centros</Typography>

                <NeuriteGrid
                    id="u_c"
                    columns={[
                        { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 150 },
                        { key: 'perfil', name: 'Perfil', editable: false, dragable: false, width: 165 },
                    ]}
                    rows={this.state.usuarioCentros}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={true}
                    onNewRowClick={this.newCentro}
                    onEditClick={this.editCentro}
                    onDeleteClick={this.removeCentro}
                    height={200}
                />
            </div>
        );
    };
};


UsuarioCentros.propTypes = {
    //state
    usuarioCentros: PropTypes.array.isRequired,

};

const mapStateToProps = state => {
    return {
        usuarioCentros: state.usuarioCentros.usuarioCentros,
        centros: state.centros.centros,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addUsuarioCentro,
        removeUsuarioCentro,
        modifyUsuarioCentro,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(UsuarioCentros));